/**
 * Copyright 2022 (C) Blink - All Rights Reserved
 *
 * This source code is protected under international copyright law.  All rights
 * reserved and protected by the copyright holders.
 * All files are confidential and only available to authorized individuals with the
 * permission of the copyright holders. If you encounter any file and do not have
 * permission, please get in touch with the copyright holders and delete this file.
 */

import { Heading, HR, Stack } from "components";
import DynamicFields from "./DynamicFields";

/**
 * Standardized Section Component for Guest Info Form
 * Provides consistent spacing, structure, and title handling
 */
const FormSection = ({
  sectionKey,
  title,
  showTitle = true,
  sections,
  sectionsData,
  dynamicFieldValues,
  dynamicFieldErrors,
  updateDynamicField,
  isReviewing,
  isFormDisabled,
  onDisabledClick,
  showDivider = true,
  customProps = {},
  className = "",
  children,
}) => {
  const sectionFields = sections[sectionKey]?.fields;
  const hasFields = sectionFields && Object.keys(sectionFields).length > 0;
  
  // Don't render if no fields
  if (!hasFields && !children) {
    return null;
  }

  // Get title from multiple sources with fallback
  const sectionTitle = title || 
                      sectionsData[sectionKey]?.title || 
                      sections[sectionKey]?.title;

  return (
    <>
      <Stack
        component="section"
        onClick={onDisabledClick}
        className={`gap-y-8 ${className}`}
      >
        {sectionTitle && showTitle && (
          <Heading
            as="h2"
            className="-text--theme-colors-text-title-brand"
          >
            {sectionTitle}
          </Heading>
        )}
        
        {children}
        
        {hasFields && (
          <DynamicFields
            sectionKey={sectionKey}
            fields={sectionFields}
            values={dynamicFieldValues}
            errors={dynamicFieldErrors}
            onChange={updateDynamicField}
            isReviewing={isReviewing}
            isFormDisabled={isFormDisabled}
            {...customProps}
          />
        )}
      </Stack>
      
      {showDivider && <HR className="!my-0" />}
    </>
  );
};

export default FormSection;
